
import { defineComponent, reactive, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import HistAreaTbl from '@/components/HistAreaTbl.vue'
import { User } from '@/types/clsUser'
import { app } from '../main'
import { distributeWay } from '../BizTerms'

/* eslint-disable camelcase */
interface areaRow {
  area_id: string;
  key_code: string;
  town: string;
  order_qty: number;
  resval: number;
  get_order_qty: number;
  get_order_mnt: number;
  rescom: string;
}

export default defineComponent({
  components: { HistAreaTbl },
  props: ['user'],
  setup (props, context) {
    const router = useRouter()
    if (!props.user.login) {
      console.log('Can\'t access OrderDetail for not login.')
      router.push('/login')
    }
    const route = useRoute()
    const loading = ref(false)
    const dialogVisible = ref(false)
    const isShowConf = ref(false)
    const message = reactive({
      msg: '',
      err: false,
      clear () {
        this.msg = ''
        this.err = false
      }
    })
    const apiPath = app.config.globalProperties.api_path
    const orderInfo = reactive<{[index: string]: any}>({
      order_id: '',
      segment: '',
      size: '',
      order_qty: 0,
      order_price: 0,
      order_date: ''
    })
    const areaList: areaRow[] = reactive([])
    const srcList:any = reactive([])
    const delImg = reactive({
      path: '',
      msg: ''
    })
    const imgOptions = reactive({
      order_id: '',
      file_name: ''
    })
    const url = ref('')
    const uploader = apiPath + 'ajax/upload.php'
    const uplDialog = () => {
      dialogVisible.value = true
    }
    const beforeAvatarUpload = (file: any) => {
      const mime = [
        'image/jpeg',
        'image/png',
        'application/pdf'
      ]
      const isMIME = mime.includes(file.type)
      const isLt4M = file.size / 1024 / 1024 < 4

      if (!isMIME) {
        app.config.globalProperties.$message.error('アップロードできる画像はJPG、PNGまたはPDFです。')
      }
      if (!isLt4M) {
        app.config.globalProperties.$message.error('画像が4MBを超えています。')
      }
      return isMIME && isLt4M
    }
    const imgHover = reactive([false])
    const handleImgHover = (idx: number) => {
      imgHover[idx] = true
    }
    const handleImgLeave = (idx: number) => {
      imgHover[idx] = false
    }
    const handleAvatarSuccess = (res: string, file: any) => {
      if (res === 'success') {
        app.config.globalProperties.$message({
          message: `${file.name} uploaded successfully`,
          type: 'success'
        })
        getFiles()
      }
    }
    const handleDelete = (img: any) => {
      let msg = []
      const conv:{[SideA:string]: string} = { SideA: '表', SideB: '裏' }
      delImg.path = img.replace(/\?.*$/, '')
      msg = delImg.path.split('/')
      delImg.msg = `発注番号${msg[2]}の${conv[msg[3].split('.')[0]]}面画像`
      isShowConf.value = true
    }
    const back = () => {
      router.push('/hist')
    }
    const updFeedback = () => {
      const feedback:any = []
      let memo = ''
      let totalRes = 0
      // 反響数入力エリアのみ抽出
      areaList.some((row: areaRow) => {
        if (row.resval + row.get_order_qty + row.get_order_mnt > 0) {
          totalRes += row.resval + row.get_order_qty
          if ('rescom' in row) {
            memo = row.rescom
          } else {
            memo = ''
          }
          feedback.push({
            area_id: row.area_id,
            order_id: orderInfo.order_id,
            inquiry_qty: row.resval,
            get_order_qty: row.get_order_qty,
            get_order_mnt: row.get_order_mnt,
            memo: memo
          })
        }
      })
      console.log(totalRes, feedback)
      const json = {
        order_id: orderInfo.order_id,
        total: totalRes,
        list: feedback,
        csrf: props.user.csrf
      }
      fetch(apiPath + 'ajax/add_feedback.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(json)
      }).then(response => response.json())
        .then(json => {
          if (json.result === 'failure') {
            message.msg = json.error
            message.err = true
            app.config.globalProperties.$message.error('更新できませんでした。.')
          } else {
            message.clear()
            // console.log(json);
            app.config.globalProperties.$message({
              message: '更新に成功しました.',
              type: 'success'
            })
          }
        })
        .catch(error => console.error(error))
    }
    const deleteImage = () => {
      isShowConf.value = false
      const json = { path: delImg.path, csrf: props.user.csrf }
      fetch(apiPath + 'ajax/unlink.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(json)
      }).then(response => response.json())
        .then(json => {
          // console.log(json);
          if (json.result === 'failure') {
            message.msg = json.error
            message.err = true
            app.config.globalProperties.$message.error('削除できませんでした。')
          } else {
            message.clear()
            app.config.globalProperties.$message({
              message: '削除しました.',
              type: 'success'
            })
            getFiles()
          }
        })
        .catch(error => console.error(error))
    }
    const getHist = () => {
      loading.value = true
      fetch(apiPath + 'ajax/orderhist.php?order_id=' + route.query.id, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      }).then(response => response.json())
        .then(json => {
          // console.log(json);
          if (json.result === 'failure') {
            if (json.err_code === 9) {
              context.emit('login', new User())
            }
            throw new Error(json.error)
          }
          message.clear()
          Object.assign(orderInfo, json[0])
        })
        .catch(error => {
          console.error(error)
          message.msg = error.message
          message.err = true
        })
      fetch(apiPath + 'ajax/histdetail.php?order_id=' + route.query.id, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      }).then(response => response.json())
        .then(json => {
          // console.log(json);
          if (json.result === 'failure') {
            if (json.err_code === 9) {
              context.emit('login', new User())
            }
            throw new Error(json.error)
          }
          message.clear()
          Object.assign(areaList, json)
        })
        .catch(error => {
          console.error(error)
          message.msg = error.message
          message.err = true
        })
        .finally(() => {
          loading.value = false
        })
    }
    const getFiles = () => {
      fetch(apiPath + 'ajax/getFileList.php?order_id=' + route.query.id, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      }).then(response => response.json())
        .then(json => {
          // console.log(json);
          if (json.result === 'failure') {
            if (json.err_code === 9) {
              context.emit('login', new User())
            }
            throw new Error(json.error)
          }
          message.clear()
          if (json.files.length > 0) {
            const srcList2 = json.files.map((x:string) => `./upload/${route.query.id}/` + x.split('/').reverse()[0] + '?d=' + Math.random())
            srcList.splice(0)
            Object.assign(srcList, srcList2)
            url.value = srcList[0]
          } else {
            Object.assign(srcList, [])
            url.value = ''
          }
          // ファイル名決定
          let fileName = ''
          if (srcList.length < 1) {
            fileName = 'SideA'
          } else if (srcList.length < 2) {
            fileName = srcList[0].split('/').reverse()[0]
            if (fileName.split('.')[0] === 'SideA') {
              fileName = 'SideB'
            } else {
              fileName = 'SideA'
            }
          }
          if (route.query.id) {
            if (!Array.isArray(route.query.id)) {
              imgOptions.order_id = route.query.id
            }
          }
          imgOptions.file_name = fileName
        })
        .catch(error => {
          console.error(error)
          message.msg = error.message
          message.err = true
        })
    }
    getHist()
    getFiles()

    return {
      message,
      loading,
      dialogVisible,
      isShowConf,
      url,
      srcList,
      imgOptions,
      orderInfo,
      areaList,
      distributeWay,
      uplDialog,
      updFeedback,
      deleteImage,
      back,
      beforeAvatarUpload,
      handleAvatarSuccess,
      handleDelete,
      uploader,
      handleImgHover,
      handleImgLeave,
      imgHover,
      delImg
    }
  }
})
